import React, { Fragment, useEffect } from "react";

const PageNotFound = () => {
  useEffect(() => {
    const clearLocalData = () => {
      localStorage.clear(); 
    };
    clearLocalData();
  }, []);

  return (
    <Fragment>
      <div className="logout-container">
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-sm-10 col-md-8 col-lg-6">
                <div className="card shadow mb-5 mt-5 bg-white rounded text-center p-5">
                  <h1>Page Not Found</h1>
                  <h5 className="mt-1">The page you are looking for does not exist.</h5>
                  <h4 className="mt-1">🚫🚫🚫🚫</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PageNotFound;
